import { Model, RailsFormat } from "./model"

export class Campus extends Model {

  constructor(
    public id?: number,
    public name: string = "",
    public numberOfRooms: number = 0,
    public code: string = "",
    public maxEnrolments: number = 0,
    public createdAt: Date = null,
    public updatedAt: Date = null,
  ) { super() }

  static clone(obj: any) {
    const campus: Campus = new this()

    if (obj.id) { campus.id = obj.id }
    if (obj.name) { campus.name = obj.name }
    if (obj.numberOfRooms) { campus.numberOfRooms = obj.numberOfRooms }
    if (obj.code) { campus.code = obj.code }
    if (obj.maxEnrolments) { campus.maxEnrolments = obj.maxEnrolments }
    if (obj.createdAt) { campus.createdAt = new Date(obj.createdAt) }
    if (obj.updatedAt) { campus.updatedAt = new Date(obj.updatedAt) }

    return campus
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/campus.ts